import { AxiosResponse } from 'axios';

import { ITrackData, IBaseTrackMap, ITrackMap } from 'src/interfaces/TrackMap';

export interface ListCrudPaths<TFetchOptions = void> {
  list: string | ((options?: TFetchOptions) => string);
  save: string;
  update: (id: string) => string;
  delete: (id: string) => string;
  bulkDelete: string;
}

export interface ListCrudActionNames {
  fetch: string;
  save: string;
  delete: string;
  deleteAll: string;
  reset: string;
}

// TItem is a phantom type used by ListCrudActionImpl (bound at config declaration sites).
export interface ListCrudConfig<TItem = unknown, TFetchOptions = void> {
  paths: ListCrudPaths<TFetchOptions>;
  stateKey: string;
  actions: ListCrudActionNames;
  /** Phantom so TItem is referenced for callers / ListCrudActionImpl. */
  readonly __itemType?: TItem;
}

export type TrackMapSavePayload = ITrackData & IBaseTrackMap;

export interface TrackMapsSlice {
  trackMaps: ITrackMap[];
  isLoading: boolean;
  error: unknown | null;
  deleteAllTrackMaps: () => Promise<void | AxiosResponse<null>>;
  deleteTrackMap: (id: string) => Promise<void | AxiosResponse<null>>;
  fetchTrackMaps: (publishedOnly?: boolean) => Promise<void | AxiosResponse<ITrackMap[]>>;
  resetTrackMaps: () => void;
  saveTrackMap: (
    trackMap: TrackMapSavePayload,
    id?: string,
  ) => Promise<void | AxiosResponse<ITrackMap[]>>;
}

export const TRACK_MAPS_CRUD_CONFIG: ListCrudConfig<ITrackMap, boolean | undefined> = {
  paths: {
    list: publishedOnly => (publishedOnly ? 'trackMaps/?published=true' : 'trackMaps/'),
    save: 'trackMaps',
    update: id => `trackMaps/${id}`,
    delete: id => `trackMaps/${id}`,
    bulkDelete: 'trackMaps/bulk',
  },
  stateKey: 'trackMaps',
  actions: {
    fetch: 'fetchTrackMaps',
    save: 'saveTrackMap',
    delete: 'deleteTrackMap',
    deleteAll: 'deleteAllTrackMaps',
    reset: 'resetTrackMaps',
  },
};
